import React, { useEffect } from "react";

export function GoogleButton({ OnSubmitGoogleOAuth }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: "20176689980-hs3gcae0oafjpq7ie698mn2310m5bo3g.apps.googleusercontent.com",
        callback: handleCredentialResponse,
      });

      window.google.accounts.id.renderButton(document.getElementById("google-signin"), {
        theme: "outline",
        size: "large",
      });
    };
  }, []);

  const handleCredentialResponse = async (response) => {
    const token = response.credential;

    OnSubmitGoogleOAuth(token);
  };

  return (
    <div id="google-signin" style={{ display: "flex", justifyContent: "center" }}>
      google signin
    </div>
  );
}
